import { render, staticRenderFns } from "./IdCardCollection.vue?vue&type=template&id=04b7f0ca&scoped=true&"
import script from "./IdCardCollection.vue?vue&type=script&lang=ts&"
export * from "./IdCardCollection.vue?vue&type=script&lang=ts&"
import style0 from "./IdCardCollection.vue?vue&type=style&index=0&id=04b7f0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7f0ca",
  null
  
)

export default component.exports